import BaseDecorator from "./BaseDecorator";
import ProductDecorator from "./ProductDecorator";

export default class AgentProductDealDecorator extends BaseDecorator {
  transformData(data) {
    return super.transformData({
      ...data,
      product: data.product && new ProductDecorator(data.product),
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/AgentProductDealDecorator.js